import {getAllDeliveryChallans} from '../../services/DeliveryChallanServices'
import { getAllMoisture } from '../../services/MoistureCorrectionServices';
import Swal from "sweetalert2";
import { getHTMLForSummaryPopup, getHTMLForTablePopup } from '../../utils/PopupUtils';
import {parseBooleanToString} from '../../helpers';
export function checkForDuplicateDeliveryChallans(name, value, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
      getAllDeliveryChallans(cookies)
      .then((data) => {

        let isUserExists = false;
        for(var i=0; i<data.salesrep_data.length; i++)    //Same Sales Representative Name mentioned it denoted already exist.
        {
          if((data.salesrep_data[i].entity_name) === value.trim().toUpperCase()
            && parseInt(existingId) !== data.salesrep_data[i].id){   
            
            console.log(`User exists with the name - ${value}`) 
            isUserExists = true;
            break;
          }
        }
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }

  const resolveMaterialKeyFromBinLabel = (label, fallbackKey) => {
        const raw = String(label || '').toLowerCase().trim();
        const name = raw.replace(/[^a-z0-9]/g, '');
        if (name.includes('20mm') || name === '20') return '20mm';
        if (name.includes('12mm') || name === '12') return '12mm';
        if (name.includes('msand') || (name.includes('ms') && name.includes('sand')) || name === 'sandd') return 'msand';
        if (name.includes('csand') || (name.includes('cs') && name.includes('sand'))) return 'csand';
        if (name.includes('rsand') || (name.includes('rs') && name.includes('sand'))) return 'rsand';
        // Plant configs often label M-Sand simply as "SAND".
        if (name === 'sand') return 'msand';
        return fallbackKey;
      };

  const toNumber = (value) => {
        const parsed = parseFloat(value);
        return Number.isFinite(parsed) ? parsed : 0;
      };

  const SAND_MATERIAL_KEYS = ['rsand', 'msand', 'csand'];
  const pooledSandValue = (valuesByKey, materialKey) => {
        const value = toNumber(valuesByKey?.[materialKey]);
        if (value) return value;
        if (!SAND_MATERIAL_KEYS.includes(materialKey)) return 0;
        const sandValues = SAND_MATERIAL_KEYS.map((key) => toNumber(valuesByKey?.[key]));
        const nonZero = sandValues.filter((v) => v !== 0);
        return nonZero.length ? Math.max(...nonZero) : 0;
      };

  const moistureRecordHasValues = (record) => {
        if (!record) return false;
        const groups = [record.moisture, record.absorption, record.correction_factor];
        return groups.some((group) =>
          group && Object.values(group).some((value) => toNumber(value) !== 0)
        );
      };

  const pickMoistureRecord = (records, plantId, plantAlias) => {
        const list = Array.isArray(records) ? records : [];
        const normalizedAlias = String(plantAlias || '').trim().toLowerCase();
        return (
          list.find((r) => Number(r.plant_id) === Number(plantId))
          || list.find((r) => String(r.plant_name || '').trim().toLowerCase() === normalizedAlias)
          || list.find((r) => {
              const name = String(r.plant_name || '').trim().toLowerCase();
              return normalizedAlias && name && (name.includes(normalizedAlias) || normalizedAlias.includes(name));
            })
          || list.find((r) => moistureRecordHasValues(r))
          || list[0]
        );
      };

  export async function showDmixPopup(designmix_list, plantConfig, cookies, options = {}) {
        const plant_configuration = plantConfig.plant_configuration_list[0];
        const design_mix = designmix_list.design_mix_list[0];
        const grade = design_mix.work_schedule.sales_order_detail.product.name;
        const plantId = Number(
          options.plantId
          || design_mix.work_schedule?.plant?.id
          || plant_configuration.plant?.id
          || 0
        ) || null;
        const plantAlias = String(
          options.plantAlias
          || design_mix.work_schedule?.plant?.alias_name
          || plant_configuration.plant?.name
          || ''
        ).trim().toLowerCase();

        // Default bin mapping used by batch-target calculation:
        // bin_1 -> 20mm, bin_2 -> 12mm, bin_3 -> rsand, bin_4 -> msand, bin_5 -> csand.
        let moistureValues = { '20mm': 0, '12mm': 0, rsand: 0, msand: 0, csand: 0 };
        let absorptionValues = { '20mm': 0, '12mm': 0, rsand: 0, msand: 0, csand: 0 };
        let correctionFactor = { '20mm': 0, '12mm': 0, rsand: 0, msand: 0, csand: 0 };

        const applyMoistureRecord = (record) => {
          if (!record) return false;
          const moisture = record.moisture || {};
          const absorption = record.absorption || {};
          const correction = record.correction_factor || {};
          const materialKeys = ['20mm', '12mm', 'rsand', 'msand', 'csand'];
          moistureValues = materialKeys.reduce((acc, key) => {
            acc[key] = toNumber(moisture[key]);
            return acc;
          }, {});
          absorptionValues = materialKeys.reduce((acc, key) => {
            acc[key] = toNumber(absorption[key]);
            return acc;
          }, {});
          correctionFactor = materialKeys.reduce((acc, key) => {
            // Always derive CF as Moisture - Absorption for display consistency.
            acc[key] = Number((moistureValues[key] - absorptionValues[key]).toFixed(2));
            return acc;
          }, {});
          return moistureRecordHasValues({
            moisture: moistureValues,
            absorption: absorptionValues,
            correction_factor: correctionFactor,
          });
        };

        // 1) Prefer moisture already attached by Design Mix API.
        let moistureLoaded = applyMoistureRecord(design_mix.moisture_correction);

        // 2) Always refresh from Moisture Correction API for the selected plant
        //    so updates made just before opening Design Mix icon are visible.
        if (cookies) {
          try {
            let records = [];
            if (plantId) {
              const byPlant = await getAllMoisture(cookies, { plantId });
              records = byPlant?.moisture_correction_list || [];
            }
            if (!records.length) {
              const allMoisture = await getAllMoisture(cookies);
              records = allMoisture?.moisture_correction_list || [];
            }
            const record = pickMoistureRecord(records, plantId, plantAlias);
            if (record) {
              moistureLoaded = applyMoistureRecord(record) || moistureLoaded;
            }
          } catch (error) {
            console.warn('Moisture correction unavailable:', error?.response?.data || error?.message || error);
          }
        }

        if (!moistureLoaded) {
          console.warn('No moisture correction found for plant', plantId, plantAlias);
        }

        const defaultBinKeys = ['20mm', '12mm', 'rsand', 'msand', 'csand'];
        const binConfigs = [
          { enabled: plant_configuration.is_bin_1, label: plant_configuration.bin_1, design: design_mix.agg1 || 0 },
          { enabled: plant_configuration.is_bin_2, label: plant_configuration.bin_2, design: design_mix.agg2 || 0 },
          { enabled: plant_configuration.is_bin_3, label: plant_configuration.bin_3, design: design_mix.agg3 || 0 },
          { enabled: plant_configuration.is_bin_4, label: plant_configuration.bin_4, design: design_mix.agg4 || 0 },
          { enabled: plant_configuration.is_bin_5, label: plant_configuration.bin_5, design: design_mix.agg5 || 0 },
        ].map((bin, index) => {
          const materialKey = resolveMaterialKeyFromBinLabel(bin.label, defaultBinKeys[index]);
          return {
            ...bin,
            materialKey,
            moisture: pooledSandValue(moistureValues, materialKey),
            absorption: pooledSandValue(absorptionValues, materialKey),
            cf: pooledSandValue(correctionFactor, materialKey),
          };
        });
        binConfigs.forEach((bin) => {
          // Moisture correction adds free water adjustment into aggregates:
          // corrected aggregate = design + (design × CF / 100)
          // water is reduced by the same total kg.
          bin.correctionKg = Math.round(bin.design * (bin.cf / 100));
          bin.corrected = Math.ceil(bin.design + bin.correctionKg);
        });
        const cumulativeKg = binConfigs.reduce((total, bin) => total + bin.correctionKg, 0);
        const correctedWater = (value) => (value > 0 ? value - cumulativeKg : value);

        const coarseDesign = (design_mix.agg1 || 0) + (design_mix.agg2 || 0);
        const fineDesign = (design_mix.agg3 || 0) + (design_mix.agg4 || 0) + (design_mix.agg5 || 0);
        const coarseCorrected = binConfigs[0].corrected + binConfigs[1].corrected;
        const fineCorrected = binConfigs[2].corrected + binConfigs[3].corrected + binConfigs[4].corrected;

        const columns = [{ key: 'particulars', label: 'Particulars' }];
        const designRow = { particulars: 'Design Mix' };
        const moistureRow = { particulars: 'Moisture (%)' };
        const absorptionRow = { particulars: 'Absorption (%)' };
        const correctionRow = { particulars: 'Correction Factor (%)' };
        const correctedRow = { particulars: 'Corrected' };

        const addColumn = (key, label, designValue, moistureValue, absorptionValue, correctionValue, correctedValue, align = 'right') => {
          columns.push({ key, label, align });
          designRow[key] = designValue;
          moistureRow[key] = moistureValue;
          absorptionRow[key] = absorptionValue;
          correctionRow[key] = correctionValue;
          correctedRow[key] = correctedValue;
        };

        const siloConfigs = [
          { enabled: plant_configuration.is_silo_1, label: plant_configuration.silo_1, value: design_mix.cem1 || 0 },
          { enabled: plant_configuration.is_silo_2, label: plant_configuration.silo_2, value: design_mix.cem2 || 0 },
          { enabled: plant_configuration.is_silo_3, label: plant_configuration.silo_3, value: design_mix.cem3 || 0 },
          { enabled: plant_configuration.is_silo_4, label: plant_configuration.silo_4, value: design_mix.cem4 || 0 },
          { enabled: plant_configuration.is_silo_5, label: plant_configuration.silo_5, value: design_mix.cem5 || 0 },
        ];
        siloConfigs.forEach((silo, index) => {
          if (silo.enabled) {
            addColumn(`silo_${index + 1}`, silo.label, silo.value, '', '', '', silo.value);
          }
        });
        addColumn('total_cem', 'Total Cem', design_mix.total_cem, '', '', '', design_mix.total_cem);

        binConfigs.forEach((bin, index) => {
          if (bin.enabled) {
            addColumn(`bin_${index + 1}`, bin.label, bin.design, bin.moisture, bin.absorption, bin.cf, bin.corrected);
          }
          if (index === 1) {
            addColumn('coarse_aggregate', 'Coarse Agg', coarseDesign, '', '', '', coarseCorrected);
          }
        });
        addColumn('fine_aggregate', 'Fine Agg', fineDesign, '', '', '', fineCorrected);

        const otherConfigs = [
          { enabled: plant_configuration.is_other_1, label: plant_configuration.other_1, value: design_mix.water1 || 0, corrected: correctedWater(design_mix.water1 || 0) },
          { enabled: plant_configuration.is_other_2, label: plant_configuration.other_2, value: design_mix.water2 || 0, corrected: correctedWater(design_mix.water2 || 0) },
          { enabled: plant_configuration.is_other_3, label: plant_configuration.other_3, value: design_mix.adm1 || 0, corrected: design_mix.adm1 || 0 },
          { enabled: plant_configuration.is_other_4, label: plant_configuration.other_4, value: design_mix.adm2 || 0, corrected: design_mix.adm2 || 0 },
          { enabled: plant_configuration.is_other_5, label: plant_configuration.other_5, value: design_mix.others || 0, corrected: design_mix.others || 0 },
        ];
        otherConfigs.forEach((other, index) => {
          if (other.enabled) {
            addColumn(`other_${index + 1}`, other.label, other.value, '', '', '', other.corrected);
          }
        });

        addColumn('density', 'Density', design_mix.density, '', '', '', '');
        addColumn('wc_ratio', 'WC Ratio', design_mix.water_cem, '', '', '', '');

    Swal.fire({
      html: getHTMLForTablePopup(
        `DESIGN MIX - ${grade}`,
        columns,
        [designRow, moistureRow, absorptionRow, correctionRow, correctedRow],
      ),
      width: '1080px',
      confirmButtonText: 'Close',
    });
  }
  export function showBillingPop(selectedCustomer){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'BILLING DETAILS',
          [
            {label: 'BILLING NAME', value: selectedCustomer.name},
          {label: 'ADDRESS', value: selectedCustomer.address_1},
          {value: selectedCustomer.address_2},
          {value: selectedCustomer.address_3},
          {label: 'SALES OFFICER', value: selectedCustomer.salesrep.name},
          
          ])
  }, '', 'info');
  }
  export function showCustomerSitePop(consignee){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'DELIVERY DETAILS',
          [
            {label: 'DELIVERY NAME', value: consignee.name},
            {label: 'ADDRESS', value: consignee.address_1},
            {value: consignee.address_2},
            {value: consignee.address_3},
          ])
  }, '', 'info');   

  }
  export function showWorkschedulePop(selectedWorkSchedule){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'WORKSCHEDULE DETAILS',
          [
          
          {label: 'WORK ORDER NO.', value: selectedWorkSchedule.schedule_no},
          {label: 'WORK ORDER DATE', value: selectedWorkSchedule.schedule_date},
          {label: 'MODE OF DELIVERY', value: (selectedWorkSchedule.delivery_mode || '').toString().toUpperCase()},
          {label: 'PUMP NO', value: selectedWorkSchedule.pump.name},
          {label: 'GANG', value: selectedWorkSchedule.gang.name},
          {label: 'IS EXTRA CHUTE REQUIRED?', value: parseBooleanToString(selectedWorkSchedule.is_extra_shut_required)},
          
          ])
  }, '', 'info');
  }
  export function showSalesorderPop(selectedWorkSchedule){
    Swal.fire({
      html:getHTMLForSummaryPopup(
         'SALES ORDER DETAILS',
         [
           
           {label: 'SO DATE', value: selectedWorkSchedule.sales_order_detail.sales_order.order_date},
           {label: 'CUSTOMER P.O NO', value: selectedWorkSchedule.sales_order_detail.sales_order.purchase_order_no},
           {label: 'MODE OF TRANSPORT', value: selectedWorkSchedule.sales_order_detail.sales_order.transport_mode},
           {label: 'SALES ORDER QTY', value: selectedWorkSchedule.sales_order_detail.order_quantity},
           
  
         ])
  }, '', 'info'); 
  }
  export function showProjectrPop(delivery_details){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'PROJECT/SITE DETAILS',
          [
            {label: 'PROJECT/SITE', value: delivery_details.project_name},
            {label: 'CONTACT NAME', value: delivery_details.contact_person},
            {label: 'MOBILE NUMBER', value: delivery_details.mobile_number},
            {label: 'DESIGNATION', value: delivery_details.contact_designation},
                  ])
  }, '', 'info');   
  }
